import React from "react";
import { Row, Col } from 'antd';
//
import '@/stylesheets/CommonBoxLinks.scss';
//
import config from '@/config/config';
//
export default class CommonBoxLinks extends React.Component {
  render() {
    if (!(config.Theme.privacyURL && config.Theme.helpURL)) return (<></>);
    return (
      <Row type="flex" justify="center" align="middle" className='containerLinks'>
        <div className='containerBoxLinks' {...(this.props.width ? {style: {width: this.props.width}} : {})}>
          <Col span={12}>
            <a className="containerPrivacyLabel" href={config.Theme.privacyURL}>Privacy policy</a>
          </Col>
          <Col span={12} align="end">
            <a className="containerHelpLabel" href={config.Theme.helpURL}> Need help?</a>
          </Col>
        </div>
      </Row>
    )
  }
}
